function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.45 16.8C6.05 16.2 7.05 16.2 7.55 16.8L9.45 18.7V2.10005C9.45 1.30005 10.15 0.500047 10.95 0.600047C11.35 0.600047 11.75 0.800047 12.05 1.10005C12.35 1.40005 12.45 1.80005 12.55 2.20005V18.8L14.45 16.9C15.05 16.3 16.05 16.3 16.55 16.9C17.15 17.5 17.15 18.5 16.55 19L12.05 23.4L11.95 23.5L11.85 23.6C11.85 23.6 11.85 23.6 11.75 23.7L11.65 23.8L11.05 23.9H10.95C10.95 23.9 10.95 23.9 10.85 23.9V23.6V23.9H10.45V23.7L10.25 23.9L10.15 23.8L10.05 23.7L9.95 23.6C9.85 23.5 9.85 23.5 9.85 23.5L5.45 19.1C4.95 18.4 4.95 17.4 5.45 16.8Z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 28,
  width: 22,
  height: 3,
  rx: 1.5
});

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d72dabd4.svg";
export { ForwardRef as ReactComponent };